import React from "react";
import { ExternalLink } from "lucide-react";

interface FooterProps {
  className?: string;
}

const Footer = ({ className = "" }: FooterProps) => {
  return (
    <footer
      className={`bg-background border-t border-border py-4 ${className}`}
    >
      <div className="flex items-center gap-6 pl-6">
        <a
          href="https://w.amazon.com/bin/view/AWS/WWRO/SEPS/SMIE/TACO/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-sm font-medium inline-flex items-center gap-1"
        >
          Wiki
          <ExternalLink className="h-3 w-3" />
        </a>

        <a
          href="https://amazon.enterprise.slack.com/archives/C0B1HCUL6QN"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 text-sm font-medium inline-flex items-center gap-1"
        >
          Slack channel
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
